"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = require("../../index");

var _discard_definition = _interopRequireDefault(require("./discard_definition"));

var _definecomponent = require("../../../utils/definecomponent");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
// material
// definition

/* ========== ~~~~~~~~~~ EXPORT : DISCARD BUTTON ~~~~~~~~~~ ========== */


var DiscardButton = function DiscardButton(props) {
  return _react.default.createElement(_index.Button, {
    type: "action",
    action: props.discardChanges,
    variant: "normal",
    name: "discard-changes",
    text: "Discard Changes",
    disabled: !!props.disabled
  });
};
/* ========== ~~~~~~~~~~ DEFINE COMPONENT ~~~~~~~~~~ ========== */


(0, _definecomponent.defineComponent)(DiscardButton, _discard_definition.default, false);
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

var _default = DiscardButton;
exports.default = _default;